import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  FormGroup,
} from 'reactstrap';
import { BtnOutlineGreen, BtnOutlineRed } from '../../styled-components';

const EmailModal = ({
  isOpen,
  toggle,
  selectedCount,
  onSend,
  onCancel,
  isSending = false,
}) => {
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [cc, setCc] = useState('');

  // Reset state when modal opens
  useEffect(() => {
    if (isOpen) {
      setSubject('');
      setBody('');
      setCc('');
    }
  }, [isOpen]);

  const parseCc = (ccString) => {
    if (!ccString.trim()) return [];
    return ccString
      .split(/[,;\s]+/)
      .map((email) => email.trim())
      .filter(Boolean)
      .map((email) => ({ email }));
  };

  const handleSend = () => {
    const trimmedSubject = subject.trim();
    const trimmedBody = body.trim();
    if (trimmedSubject && trimmedBody && selectedCount > 0) {
      onSend(trimmedSubject, trimmedBody, parseCc(cc));
    }
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    else toggle();
  };

  const isSendDisabled =
    !subject.trim() || !body.trim() || selectedCount <= 0 || isSending;

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleCancel}
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader toggle={handleCancel}>Invia Email</ModalHeader>
      <ModalBody>
        <p>
          {selectedCount > 0
            ? `Stai per inviare un'email a ${selectedCount} profili selezionati.`
            : 'Nessun profilo selezionato.'}
        </p>
        <FormGroup>
          <Label for="emailSubject">Oggetto</Label>
          <Input
            id="emailSubject"
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            placeholder="Inserisci l'oggetto"
          />
        </FormGroup>
        <FormGroup>
          <Label for="emailCc">CC</Label>
          <Input
            id="emailCc"
            type="text"
            value={cc}
            onChange={(e) => setCc(e.target.value)}
            placeholder="email1@example.com, email2@example.com"
          />
        </FormGroup>
        <FormGroup>
          <Label for="emailBody">Corpo dell'email</Label>
          <Input
            id="emailBody"
            type="textarea"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            placeholder="Scrivi il messaggio..."
            rows={8}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <BtnOutlineRed type="button" onClick={handleCancel}>
          Annulla
        </BtnOutlineRed>
        <BtnOutlineGreen
          type="submit"
          onClick={handleSend}
          disabled={isSendDisabled}
        >
          {isSending ? 'Invio in corso...' : 'Invia'}
        </BtnOutlineGreen>
      </ModalFooter>
    </Modal>
  );
};

export default EmailModal;
